import { useCallback, useState } from 'react';
import { TextField } from '@zep-us/zus';
import { useTranslation } from 'next-i18next';
import { validateYoutubeUrl } from '@/views/build/util/youtubeUrlValidator';
import { useFocusTarget } from '../../../focus/useFocusTarget';
import { useQuizControl } from '../../QuizControlProvider';
export const YoutubeHintInput = ({
  value,
  onChange
}: {
  value?: string;
  onChange: (value: string) => void;
}) => {
  const {
    t
  } = useTranslation(['build']);
  const {
    index
  } = useQuizControl();
  const ref = useFocusTarget<HTMLInputElement>(`quizList.${index}.hint`);
  const [isError, setIsError] = useState(false);
  const validateTargetValue = useCallback((value: string) => {
    const isValid = validateYoutubeUrl(value).isValid;
    setIsError(!isValid);
  }, []);
  return <TextField.Root required error={isError} data-sentry-element="unknown" data-sentry-component="YoutubeHintInput" data-sentry-source-file="YoutubeHintInput.tsx">
      <TextField.Input onBlur={e => {
      e.stopPropagation();
      e.preventDefault();
    }} onFocus={e => {
      e.stopPropagation();
      !!e.target.value && validateTargetValue(e.target.value);
    }} ref={ref} value={value} onChange={e => {
      onChange(e.target.value);
      validateTargetValue(e.target.value);
    }} placeholder={t('quizCreateItem.youtube.description')} maxLength={200} className="text-heading-sm-bold" data-sentry-element="unknown" data-sentry-source-file="YoutubeHintInput.tsx" />
      {isError && <TextField.HelperText>
          {t('build:quizCreateItem.alert.youtubeForm')}
        </TextField.HelperText>}
    </TextField.Root>;
};